import { UserRole } from "../../../../enums/UserRole";

export const canManageUserEmail = role =>
  [UserRole.ADMIN, UserRole.COLLABORATOR].includes(role);
